import { Grid, Stack } from "@mui/material";
import React, { Fragment } from "react";
import PendingAppointmentBody from "./PendingAppointmentBody";

export default function PendingAppointment({
  appointment,
  isStack = false,
  slimVersion = false,
  refetch,
}) {

  if (isStack) {
    return (
       <Fragment>
        <PendingAppointmentBody
            forceRefetch={refetch}
            appointment={appointment}
            slimVersion={slimVersion}
          />
        </Fragment>
    )
  }

  return (
    <Fragment>
       <Grid item xs={12} sm={6} md={4}>
          <PendingAppointmentBody
            forceRefetch={refetch}
            appointment={appointment}
            slimVersion={slimVersion}
          />
        </Grid>
    </Fragment>
  );
}
